import {default as AddIcon} from '@mui/icons-material/AddCircle';

export default AddIcon